"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileName = void 0;
var _react = _interopRequireDefault(require("react"));
var _file = require("../../../assets/icons/file.svg");
var _fileNameModule = _interopRequireDefault(require("./file-name.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var FileName = function FileName(_ref) {
  var name = _ref.name,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_fileNameModule.default['file-name'], className)
  }, /*#__PURE__*/_react.default.createElement(_file.ReactComponent, {
    className: _fileNameModule.default['file-name__icon']
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _fileNameModule.default['file-name__label'],
    title: name
  }, name));
};
exports.FileName = FileName;